import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/gallery',
    element: <GalleryPage />
  },
  {
    path: '/category/:slug',
    element: <CategoryPage />
  },
  {
    path: '/product/:id',
    element: <ProductPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
